module.exports = __webpack_public_path__ + "img/DE03860.a223b16a.png";